import React from 'react';
// import PropTypes from 'prop-types';
import { IconButton, TextField,Stack,FormControl,Select,MenuItem } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { DataGrid } from '@mui/x-data-grid'; 
// import searchFill from '@iconify/icons-eva/search-fill';
// import trash2Fill from '@iconify/icons-eva/close-outline'; 

import Iconify from '../../../components/Iconify'; 

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

const defaultTheme = createTheme();
const useStyles = makeStyles(
  (theme) =>
    createStyles({
      tableroot: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        minHeight: '60px !important',
        margin: '10px'
      },
      textField: {
        [theme.breakpoints.down('xs')]: {
          width: '100%'
        },
        margin: theme.spacing(1, 0.5, 1.5),
        '& .MuiSvgIcon-root': {
          marginRight: theme.spacing(0.5)
        },
        '& .MuiInput-underline:before': {
          borderBottom: `1px solid ${theme.palette.divider}`,
          // borderRight: `1px solid ${theme.palette.divider}`
        }
      },
      
    }),
  { defaultTheme }
);

function QuickSearchToolbar(props) {
  const classes = useStyles();

  return (
    <div className={classes.tableroot}>
      {/* <div>
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
      </div> */}
      <TextField
        variant="standard"
        value={props.value}
        onChange={props.onChange}
        placeholder=" Search…"
        className={classes.textField}
        InputProps={{
          startAdornment:  getIcon('mdi:search-fill'),
          endAdornment: (
            <IconButton
              title="Clear"
              aria-label="Clear"
              size="medium"
              style={{ visibility: props.value ? 'visible' : 'hidden' }}
              onClick={props.clearSearch}
            >
            {getIcon("mdi:close")}
            </IconButton>
          )
        }}
        
      /> 
 {props.showAssignee && <FormControl style={{minWidth:'300px', margin:'8px 4px 12px'}}> 
                                            <Select
                                                label="Assign To"
                                                id="Assign To"
                                                value={props.userid}  
                                                variant="standard"
                                                placeholder="Select Staff"
                                                name="userId" 
                                                onChange={(e)=>{ 
                                                    props.onUserChange(e)
                                                }}
                                            >
                                            <MenuItem value={0}>Select Assignee</MenuItem> 
                                            {props.assignees.map(elmt=>{
                                                return <MenuItem value={elmt.id} key={'option'+elmt.id}>{elmt.firstName+" "+elmt.lastName+"("+elmt.RoleId+")"}</MenuItem>
                                              })
                                            }
                                              </Select>
                                              </FormControl>}
    </div>
  );
}

export default class TableContent extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      allrows: props.data || [],
      rows: props.data || [],
      columns: [],
      searchText: '',
      selectionModel:[],
      userid:0,
      users:props.assignees || [],
      usertype:props.userrole  || 1
    };
    
  }

  componentDidMount() {
    this.setState({ rows: Object.assign([],this.props.data), allrows: Object.assign([],this.props.data) });
    this.setState({ columns: this.props.columns });
    this.setState({ users: this.props.assignees, usertype: this.props.userrole });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if ((nextProps.data !== prevState.rows && prevState.searchText === ''  && prevState.userid === 0)) {
      return { rows: nextProps.data, allrows: nextProps.data } ;
    }
    if(nextProps.assignees !== prevState.users){
      return {users: nextProps.assignees }
    }
    if(nextProps.data !== prevState.allrows){
      return {allrows: nextProps.data }
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      // Perform some operation here
      // this.setState({ rows: this.props.data });
    }
  }

  requestSearch(searchValue) {
    this.setState({ searchText: searchValue });
    const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
    const filteredRows = this.state.rows.filter((row) => {
      return Object.keys(row).some((field) => {
        const textvalue =
          row[field] !== null && row[field] !== undefined ? row[field].toString() : '';
        return searchRegex.test(textvalue);
      });
    });
    this.setState({ rows: filteredRows });
  }

  changeAssignee(user_id){
    this.setState({userid:user_id}, function(){
      //console.log(user_id);
    });
    const filteredRows = this.state.allrows.filter((row) => {  return row.AssignedTo === user_id;}  );  
    this.setState({ rows: filteredRows } ); 
  }

  render() {

    return (
      // style={{ height: 600, width: '100%', overflow: 'scroll' }}
      <div> 
        <DataGrid 
          autoHeight
          rows={this.state.rows}
          columns={this.state.columns}
          pageSize={10}
          rowsPerPageOptions={[5]}
          disableMultipleSelection={true}
          disableSelectionOnClick
          showColumnRightBorder={false} 
          components={{ Toolbar: QuickSearchToolbar,
            NoRowsOverlay: () => (
              <Stack style={{marginTop: '10%'}} alignItems="center" justifyContent="center">
                No records found
              </Stack>
            ),
            NoResultsOverlay: () => (
              <Stack style={{marginTop: '10%'}} alignItems="center" justifyContent="center">
                No results found
              </Stack>
            )
           }}
          componentsProps={{
            toolbar: {
              value: this.state.searchText,
              onChange: (event) => this.requestSearch(event.target.value),
              clearSearch: () => this.requestSearch(''),
              onUserChange: (event) => this.changeAssignee(event.target.value),
              userid: this.state.userid,
              assignees:this.state.users,
              usertype:this.state.usertype,
              showAssignee: this.props.showAssignee
            }
            
          }}
        />
      </div>
    );
  }
}
